<template>
    <div class="simple-form flex">
        <template v-if="auditBpNodeList.length > 0" v-for="(auditBpNode, index) in auditBpNodeList">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">{{ auditBpNode.nodeDefName }}</label>
                </div>
                <div class="form-value width-3x">
                    <div style="width: 270px;border-bottom: 1px solid #dadada" class="inline-block">
                        <el-tag class="mr5 mb5" v-for="auditBpStaff in auditBpNode.auditBpStaffList" :key="auditBpStaff.no" closable @close="removeAuditStaff(auditBpNode, auditBpStaff.no)">
                            <span>{{ auditBpStaff.name }}</span>
                        </el-tag>
                    </div>
                    <!--<el-input class="width-1-5x bottom-line" disabled type="text" :title="auditBpNode.staffNames" v-model="auditBpNode.staffNames"></el-input>-->
                    <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectAuditStaffs(auditBpNode, index)"></div>
                </div>
            </div>
        </template>
        <div class="no-data" v-if="auditBpNodeList.length <= 0 && dataCallback">
            <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
            <span class="">未设置审批节点</span>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {openOaAuditBpStaffDlg} from './selectDlg'

    import oaAuditApi from '../../api/oaAudit'

    export default {
        name: 'swb-oa-audit-bp-node-list',
        desc: '审批业务流程节点-设置审批人',
        props: {
            bizTypeCode: {
                type: String,
                default: null
            },
            pullBackFlag: {
                type: Boolean,
                default: false
            },
            bizVoucherNo: {
                type: String,
                default: null
            },
            auditSeqNo: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                auditBpNodeList: [],
                dataCallback: false
            }
        },
        created: function () {
            //
            this.getMerchtAuditBpConfInfo();
        },
        methods: {
            getMerchtAuditBpConfInfo: function () {
                let self = this;
                let filterItems = {};
                filterItems.bizTypeCode = self.bizTypeCode;
                filterItems.pullBackFlag = self.pullBackFlag;
                let theLoad = MsgBox.loading();
                oaAuditApi.getMerchtAuditBpConfInfo(filterItems, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let merchtAuditBpConfInfo = result.data || {};
                        if (!merchtAuditBpConfInfo.ready || !merchtAuditBpConfInfo.needAssignAuditors) {
                            let msg = !merchtAuditBpConfInfo.ready ? "未就绪" : "无需指定审批人员";
                            MsgBox.warning("审批业务流程配置，" + msg + "请确认");
                            //
                            self.$emit('other-close', {});
                        }
                        //
                        self.getMerchtAuditBpNodeList(merchtAuditBpConfInfo.id, merchtAuditBpConfInfo.bizTypeId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取流程实例 - 重复提交时回显人员
            getMerchtAuditBpInst: function (bizTypeId, callbackFunc) {
                let self = this;
                let filterItems = {};
                filterItems.bizTypeId = bizTypeId;
                filterItems.bizVoucherNo = self.bizVoucherNo;
                filterItems.auditSeqNo = self.auditSeqNo;
                let theLoad = MsgBox.loading();
                oaAuditApi.getMerchtAuditBpInstByFilter(filterItems, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let auditBpInst = result.data || [];
                        //
                        let bpAuditorList = auditBpInst.bpAuditorList || [];
                        callbackFunc(bpAuditorList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getMerchtAuditBpNodeList: function (bpConfId, bizTypeId) {
                let self = this;
                let filterItems = {};
                filterItems.bpConfId = bpConfId;
                let theLoad = MsgBox.loading();
                oaAuditApi.getMerchtAuditBpNodeList(filterItems, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let auditBpNodeList = result.data || [];
                        //
                        self.getMerchtAuditBpInst(bizTypeId, function (bpAuditorList) {
                            for (let i = 0; i < auditBpNodeList.length; i++) {
                                let auditBpNode = auditBpNodeList[i];
                                //
                                let staffIds = [];
                                let staffNames = [];
                                // 显示默认的审批人员
                                if (!Utils.isNoB(auditBpNode.defAuditorIds)) {
                                    staffIds = auditBpNode.defAuditorIds.split("|");
                                    staffNames = auditBpNode.defAuditorNames.split("|");
                                }
                                // 回显已选择的审批人员
                                if (bpAuditorList.length > 0) {
                                    let bpAuditor = bpAuditorList.find(function (item) {
                                        return item.nodeDefId == auditBpNode.nodeDefId;
                                    });
                                    staffIds = bpAuditor.staffIds || [];
                                    staffNames = bpAuditor.staffNames || [];
                                }
                                auditBpNode.staffIds = staffIds;  // ['000001', '000002']
                                auditBpNode.staffNames = staffNames;// ['杨晓慧', '张美佳']
                                if (staffIds.length > 0) {
                                    let auditBpStaffList = [];
                                    for (let s = 0; s < staffIds.length; s++) {
                                        auditBpStaffList.push({no: staffIds[s], name: staffNames[s]});
                                    }
                                    auditBpNode.auditBpStaffList = auditBpStaffList;
                                }
                            }
                            self.auditBpNodeList = Utils.merge([], auditBpNodeList);
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                    self.dataCallback = true;
                });
            },
            // 选择审核人
            selectAuditStaffs: function (auditBpNode, index) {
                let self = this;
                let selectStaffList = auditBpNode.auditBpStaffList || [];
                openOaAuditBpStaffDlg({oldSelectStaffList: selectStaffList}, function (auditBpStaffList) {
                    auditBpNode.staffIds = Utils.merge([], auditBpStaffList.pluck("no"));
                    auditBpNode.staffNames = Utils.merge([], auditBpStaffList.pluck("name"));
                    //
                    auditBpNode.auditBpStaffList = Utils.merge([], auditBpStaffList);
                    //
                    let auditBpNodeList = self.auditBpNodeList || [];
                    auditBpNodeList[index] = Utils.merge({}, auditBpNode);
                    self.auditBpNodeList = Utils.merge([], auditBpNodeList);
                })
            },
            removeAuditStaff: function (auditBpNode, staffNo) {
                let auditBpStaffList = auditBpNode.auditBpStaffList || [];
                for (let i = 0; i < auditBpStaffList.length; i++) {
                    if (auditBpStaffList[i].no == staffNo) {
                        auditBpStaffList.splice(i, 1);
                        break;
                    }
                }
                auditBpNode.auditBpStaffList = Utils.merge([], auditBpStaffList);
            },
            getDlgResult: function () {
                let result = {
                    type: 'info'
                };
                let message = null;
                let oaAuditStaffs = [];
                let auditBpNodeList = this.auditBpNodeList || [];
                for (let i = 0; i < auditBpNodeList.length; i++) {
                    let auditBpNode = auditBpNodeList[i];
                    //
                    if (Utils.isNoB(auditBpNode.auditBpStaffList) || auditBpNode.auditBpStaffList.length <= 0) {
                        message = '节点' + auditBpNode.nodeDefName + '未设置审核人';
                        break;
                    }
                    let staffIds = auditBpNode.auditBpStaffList.pluck("no") || [];
                    let staffNames = auditBpNode.auditBpStaffList.pluck("name") || [];
                    if (staffIds.length <= 0 || staffNames.length <= 0) {
                        message = '节点' + auditBpNode.nodeDefName + '未设置审核人';
                        break;
                    }
                    let oaAuditStaffsInfo = {};
                    oaAuditStaffsInfo.nodeDefId = auditBpNode.nodeDefId;
                    oaAuditStaffsInfo.nodeDefName = auditBpNode.nodeDefName;
                    oaAuditStaffsInfo.staffIds = Utils.merge([], staffIds);
                    oaAuditStaffsInfo.staffNames = Utils.merge([], staffNames);
                    oaAuditStaffs.push(oaAuditStaffsInfo);
                }
                if (!Utils.isNoB(message)) {
                    result.type = 'warn';
                    result.message = message;
                    return result;
                }
                result.data = oaAuditStaffs;
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/oaAudit/MerchtAuditBpNodeList.vue